import DropDownButtonLegacy from 'common/components/drop-downs/legacy/dropDownButtonLegacy';
import SelectedItemButtonContainerContent from 'common/components/drop-downs/legacy/selectedItemDropDownButtonContainerContent';
import { FC } from 'react';
import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';

export const Pagination: FC<{
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  currentPageSize: number;
  pageSizes: DropDownItemType[];
  isSticky: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
  onPageSizeChanged: (pageSizeKey: number) => void;
}> = ({
  currentPage,
  totalPages,
  totalRecords,
  pageSizes,
  currentPageSize,
  isSticky,
  onNextPage,
  onPreviousPage,
  onPageSizeChanged
}) => {
  return (
    <div
      className={`flex no-wrap items-center justify-center bg-white ${
        isSticky ? 'sticky bottom-0 z-20' : ''
      }`}
    >
      <button
        disabled={currentPage <= 1}
        className={`text-sm pt-0 p-1 my-1 text-center text-navy`}
        onClick={onPreviousPage}
      >
        <i className="ra-icons-generic-down-arrow text-xs flex rotate-90"></i>
      </button>

      <span className="text-sm pt-0.5 p-1 my-1 text-center text-black">
        {totalPages > 0 ? currentPage : 0}
      </span>
      <span className="text-sm pt-0.5 p-1 my-1 text-center text-black">of</span>
      <span className="text-sm pt-0.5 p-1 my-1 text-center text-black">
        {totalPages}
      </span>
      <span className="text-sm pt-0.5 p-1 my-1 text-center text-black">
        Total Records: {totalRecords ?? 0}
      </span>

      <button
        disabled={currentPage >= totalPages}
        className={`text-sm pt-0 p-1 my-1 text-center text-black`}
        onClick={onNextPage}
      >
        <i className="ra-icons-generic-down-arrow text-xs flex -rotate-90"></i>
      </button>

      <DropDownButtonLegacy
        dropDownItems={pageSizes}
        selectDropDownItem={(pageSizeKey) => onPageSizeChanged(+pageSizeKey)}
        additionalChildProps={{ selectedItem: currentPageSize }}
        dropdownYPositionClass="bottom-7"
      >
        <SelectedItemButtonContainerContent
          styles={{
            mainContainerDivStyles: 'text-sm my-1 justify-center',
            angleDownIconStyles: 'pl-1 pr-1 pt-1.5 pb-0 text-xs'
          }}
          onRenderSelectedItem={(selectedPageSize: number) => (
            <span className="p-1 pt-1 pb-0.5 pr-0.5 text-center">
              Page Size: {selectedPageSize}
            </span>
          )}
        />
      </DropDownButtonLegacy>
    </div>
  );
};
